import axios from 'axios';
import { VriAPIResponse, VriAPIResult } from '../types';
import END_POINT from '../config/endpoints.constants';

export interface CallRatingRequestPayload {
    userId: string;
    requestId: string;
    rating: number;
    comment: string;
    providerId: string;
    callQualityRating: number;
    callQualityComment: string;
}

export interface MakeRatingResult extends VriAPIResult {}
export interface MakeRatingResponse extends VriAPIResponse {
    data?: object;
}
export const makeRatingCall = async (payload: CallRatingRequestPayload) => {
    const result = {} as MakeRatingResult;
    try {
        await axios.post<MakeRatingResponse>(END_POINT.CUSTOMER_CREATE_RATING, payload);
    } catch (error) {
        result.error = error;
    }
    return result;
};
